import { Box, CircularProgress, Typography } from '@mui/material';
import ContactInfoPopup from '../../../../../ContactInfoPopup';
import useImage from '../../../../hooks/useImage';
import { useState } from 'react';
import { IBusiness } from '@trii/types/dist/Contacts';
import { useEditContactApi } from '../../../../context/EditContactApiContext';
import { isBusiness } from '../../../../types/is-business.typeguard';
import { useNavigateContext } from '../../../../context/NavigateContext';

type Props = {
  value: string;
  displayValue: string;
  businessId: string;
};

function SelectBusinessLabel({ value, displayValue, businessId }: Props) {
  const api = useEditContactApi();
  const navigate = useNavigateContext();

  const [businessData, setBusinessData] = useState<IBusiness | null>(null);
  const userImage = useImage({
    initialImageUrl: businessData?.imageUrl,
    entityType: 'business',
    entityId: businessId,
  });

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isLoadingData, setIsLoadingData] = useState(false);

  const handleOpenInfoPopover = async (event: React.MouseEvent<HTMLElement>) => {
    // Store the target element before any async operations
    const targetElement = event.currentTarget;

    setIsLoadingData(true);

    if (!api) {
      console.error('API is null');
      return;
    }

    const response = await api.fetchBusiness({ businessId: businessId });

    if (response && isBusiness(response)) {
      setBusinessData(response);
    }

    setIsLoadingData(false);

    if (!targetElement) {
      console.error('Target element is null');
      return;
    }

    setAnchorEl(targetElement);
  };

  return (
    <Box display="flex" alignItems="center">
      <Typography
        onClick={handleOpenInfoPopover}
        variant="body2"
        fontWeight={'600'}
        sx={{
          padding: 1,
          cursor: 'pointer',
        }}
        color={(theme) => theme.palette.text.primary}
      >
        {displayValue || (typeof value === 'string' && value) || '-'}
      </Typography>
      {businessData && (
        <ContactInfoPopup
          contactData={businessData}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          navigate={navigate}
          avatarImgUrl={userImage.imageUrl}
        />
      )}
      {isLoadingData && (
        <Box display="flex" alignItems="center" justifyContent="center" p={1}>
          <CircularProgress size={20} />
        </Box>
      )}
    </Box>
  );
}

export default SelectBusinessLabel;
